import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-testimontions',
  templateUrl: './home-testimontions.component.html',
  styleUrls: ['./home-testimontions.component.scss'],
})
export class HomeTestimontionsComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
